import { Button } from "@mui/material";
import { useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import Strings from "../../../../resources/Strings";
import classes from "../CustomInputs.module.css";
import TextInput from "../CustomInputs/TextInput";

const ScanFobInput = forwardRef((props, ref) => {
  const inputRef = useRef();

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  useImperativeHandle(ref , () => ({
    inputRef
  }));
  
  return (
    <div className={classes.customTextField}>
      <div className={classes.codeVerification}>
        <span className={classes.verificationMessage}>
          {Strings.SCAN_FOB_MESSAGE}
        </span>
        <div className={classes.action}>
          <TextInput
            label={props.label}
            id={props.id}
            value={props.value}
            autoFocus={true}
            ref={inputRef}
            onChange={props.onChange}
            isStepSubmitted={props.isStepSubmitted}
            handleError={false}
            hasError={props.hasError}
            errorMessage={props.errorMessage ? props.errorMessage : ""}
          />
          <Button
            className={classes.formButton}
            onClick={props.handleConfirmScanFob}
          >
            {Strings.CONFIRM}
          </Button>
          {props?.handleResetFob && (
            <Button
              className={classes.cancelButton}
              onClick={props.handleResetFob}
            >
              {Strings.RESET}
            </Button>        
          )}
          {props?.handleSkip && (
            <Button
              className={classes.cancelButton}
              onClick={props.handleSkip}
            >
              {Strings.SKIP}
            </Button>        
          )}

          <Button className={classes.cancelButton} onClick={props.handleClose}>
            {Strings.CANCEL}
          </Button>
        </div>
        {/* {!isVerifiy && (
      <div className={classes.error}>{verifiyErrorMessage}</div>
    )} */}
      </div>
    </div>
  );
}); // added ) - for forward ref

export default ScanFobInput;
